import type React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { FlexColumn, Typography } from '@components/ui'

import maintenanceIllustrationSrc from '@assets/img/tms_maintenance.png'

const Wrapper = styled(FlexColumn)`
  gap: 30px;
  max-width: 730px;
  text-align: center;
  margin: 0 auto;
  align-items: center;
  height: 100%;
  justify-content: center;
`

const StyledImg = styled.img`
  width: 240px;
  height: auto;
`

interface MaintenanceViewProps {
  children: React.ReactNode
  isMaintenanceMode: boolean
}

function PureMaintenanceView({ children, isMaintenanceMode }: MaintenanceViewProps) {
  if (isMaintenanceMode) {
    return (
      <Wrapper>
        <StyledImg role="presentation" alt="" src={maintenanceIllustrationSrc} />
        <Typography size="heading-1" color="gray-80">
          <FormattedMessage id="page.maintenance.title" defaultMessage="Dolgozunk a háttérben" />
        </Typography>
        <Typography color="gray-80">
          <FormattedMessage
            id="page.maintenance.text"
            defaultMessage="Jelenleg technikai átállás zajlik, ezért most nem tudod elérni ezt a felületet."
          />
        </Typography>
        <Typography color="gray-80">
          <FormattedMessage
            id="page.maintenance.text2"
            defaultMessage="Kérjük, próbáld meg körülbelül 5-15 perc múlva újra, a Számlázz.hu  felületéről ismét átlépve."
          />
        </Typography>
      </Wrapper>
    )
  }

  return children
}

export const MaintenanceView = connect((state: Store) => ({
  isMaintenanceMode: state.auth.company.isMaintenanceMode,
}))(PureMaintenanceView)

MaintenanceView.displayName = 'MaintenanceView'
